import { createSlice } from '@reduxjs/toolkit';
import { findPropertyFeature, createPropertyFeature, getPropertyFeature } from './api';
import { initialState } from './api/interface';

const propertyFeatureSlice = createSlice({
  name: 'propertyFeature',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPropertyFeature.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPropertyFeature.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPropertyFeature.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createPropertyFeature.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createPropertyFeature.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createPropertyFeature.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getPropertyFeature.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPropertyFeature.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getPropertyFeature.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = propertyFeatureSlice.actions;
export default propertyFeatureSlice.reducer;